<mat-icon style="width: 1em; height: 1em; color: #DEE7F1; font-size: 100px;" fontSet="design">lock</mat-icon>
<p class="mt-4 text-body-secondary">
  <ng-container i18n="@@global.messages.noPermissionError">
    You do not have permission to access this page.
  </ng-container>
</p>
<div class="pt-5 pb-4"></div>